import { render, staticRenderFns } from "./pwd-change.vue?vue&type=template&id=053388b3&scoped=true&"
import script from "./pwd-change.vue?vue&type=script&lang=js&"
export * from "./pwd-change.vue?vue&type=script&lang=js&"
import style0 from "./pwd-change.vue?vue&type=style&index=0&id=053388b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053388b3",
  null
  
)

export default component.exports